import { Formik } from "formik";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import SmallLoader from "../../../SmallLoader";
import { MdError } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import getPlatformInfo, { notifySuccess } from "../../../../action/customFn";
import axios from "../../../../axios";
import { setLogin } from "../../../../action/loginAction";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import OTPInput from "react-otp-input";

function CompanyLoginForm({ googleError, setGoogleError }) {
  const userIpInfo = useSelector((state) => state?.paymentData?.userIpInfo);
  const [tooManySessions, setTooManySessions] = useState({
    status: false,
    email: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      {tooManySessions?.status ? (
        <Formik
          initialValues={{ otp: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.otp) {
              errors.otp = "OTP is Required";
            }
            return errors;
          }}
          onSubmit={async (values, { setSubmitting, setStatus }) => {
            try {
              const url = "/auth/login-otp";
              const postData = {
                email: tooManySessions.email,
                deviceInfo: getPlatformInfo(),
                userIpInfo: userIpInfo.ip,
                otp: values.otp,
              };
              const res = await axios.post(url, postData);
              const { message, data, token, sessionId, usedOTP } = res.data;
              dispatch(setLogin());
              localStorage.setItem("MetBrains_token", token);
              localStorage.setItem("MetBrains_role", data.typeOfUser);
              localStorage.setItem("MetBrains_id", data._id);
              localStorage.setItem("MetBrains_tracker_session_id", sessionId);
              localStorage.setItem("usedOTP", usedOTP);
              notifySuccess(message);
              setSubmitting(false);
              if (data?.userOptions?.length > 1) {
                navigate("/user-accounts");
              } else if (data.typeOfUser === "Student") {
                navigate("/dashboard");
              } else {
                navigate("/blog-dashboard/home");
              }
            } catch (error) {
              console.log(error);
              setStatus({
                error: true,
                message: error.response?.data?.message,
              });
              if (error instanceof AxiosError) {
                if (error.response?.status === 419) {
                  setTooManySessions({ status: true, email: "" });
                }
              }
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            status,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <AnimatePresence>
                {(status?.error || googleError?.error) && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="error-holder"
                  >
                    <div style={{ width: "20px", fontSize: "20px" }}>
                      <MdError />
                    </div>
                    <span>{status?.message || googleError?.msg}</span>
                  </motion.div>
                )}
              </AnimatePresence>
              {!status && <div style={{ marginTop: "20px" }}></div>}
              <AnimatePresence>
                {errors.otp && touched.otp && (
                  <motion.div
                    key={"otp_error_msg"}
                    style={{
                      margin: "0px",
                      marginBottom: "-10px",
                      color: "#d3351a",
                      fontWeight: "600",
                      fontSize: "13px",
                    }}
                    initial={{ opacity: 0, height: 0 }}
                    exit={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                  >
                    {errors.otp && touched.otp && errors.otp}
                  </motion.div>
                )}
              </AnimatePresence>
              <div style={{ position: "relative" }}>
                <OTPInput
                  value={values.otp}
                  onChange={(str) => {
                    setFieldValue("otp", str);
                  }}
                  numInputs={5}
                  inputType="tel"
                  containerStyle={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                    gap: "30px",
                  }}
                  renderInput={(props) => (
                    <input
                      {...props}
                      style={{
                        textAlign: "center",
                        aspectRatio: "1/1",
                        marginBottom: "20px",
                      }}
                    />
                  )}
                  inputStyle={"login_otp_inp"}
                />
              </div>

              <button disabled={isSubmitting} className="submit" type="submit">
                {isSubmitting ? <SmallLoader color={"#ffff"} /> : "Sign in"}
              </button>
            </form>
          )}
        </Formik>
      ) : (
        <Formik
          initialValues={{ email: "", password: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.email) {
              errors.email = "Email is Required";
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = "Invalid email address";
            }
            if (!values.password) {
              errors.password = "Password is Required";
            }
            return errors;
          }}
          onSubmit={async (values, { setSubmitting, setStatus }) => {
            try {
              const url = "/auth/login?company=true";
              const postData = {
                email: values.email.toLocaleLowerCase(),
                password: values.password,
                deviceInfo: getPlatformInfo(),
                userIpInfo: userIpInfo.ip,
              };
              const res = await axios.post(url, postData);
              const { message, data, token, sessionId } = res.data;
              dispatch(setLogin());
              localStorage.setItem("MetBrains_token", token);
              localStorage.setItem("MetBrains_role", data.typeOfUser);
              localStorage.setItem("MetBrains_id", data._id);
              localStorage.setItem("MetBrains_tracker_session_id", sessionId);
              localStorage.removeItem("session_expired");
              localStorage.removeItem("usedOTP");
              notifySuccess(message);
              setStatus(null);
              setSubmitting(false);
              dispatch({
                type: "SESSION_HAS_EXPIRED",
                payload: false,
              });
              if (data?.userOptions?.length > 1) {
                navigate("/user-accounts");
              } else if (data.typeOfUser === "Student") {
                navigate("/dashboard");
              } else if (data.typeOfUser === "Company") {
                navigate("/company-dashboard");
              } else {
                navigate("/blog-dashboard/home");
              }
            } catch (error) {
              console.log(error);
              setStatus({
                error: true,
                message: error.response?.data?.message,
              });
              if (error instanceof AxiosError) {
                if (error.response?.status === 419) {
                  setTooManySessions({
                    status: true,
                    email: values.email.toLocaleLowerCase(),
                  });
                }
              }
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            status,
          }) => (
            <form onSubmit={handleSubmit}>
              <AnimatePresence>
                {(status?.error || googleError?.error) && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="error-holder"
                  >
                    <div style={{ width: "20px", fontSize: "20px" }}>
                      <MdError />
                    </div>
                    <span>{status?.message || googleError?.msg}</span>
                  </motion.div>
                )}
              </AnimatePresence>
              {!status && <div style={{ marginTop: "20px" }}></div>}
              <AnimatePresence>
                {errors.email && touched.email && (
                  <motion.div
                    key={"email_error_msg"}
                    style={{
                      margin: "0px",
                      marginBottom: "-10px",
                      color: "#d3351a",
                      fontWeight: "600",
                      fontSize: "13px",
                    }}
                    initial={{ opacity: 0, height: 0 }}
                    exit={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                  >
                    {errors.email && touched.email && errors.email}
                  </motion.div>
                )}
              </AnimatePresence>
              <div style={{ position: "relative" }}>
                <input
                  id="login__email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="email"
                  name="email"
                  placeholder="Email"
                  style={
                    errors.email && touched.email
                      ? { border: "2px solid #d3351a" }
                      : {}
                  }
                />
                {errors.email && touched.email && (
                  <MdError
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "20px",
                      color: "#d3351a",
                    }}
                  />
                )}
              </div>
              <AnimatePresence>
                {errors.password && touched.password && (
                  <motion.div
                    key={"password_error_msg"}
                    style={{
                      margin: "0px",
                      marginBottom: "-10px",
                      color: "#d3351a",
                      fontWeight: "600",
                      fontSize: "13px",
                    }}
                    initial={{ opacity: 0, height: 0 }}
                    exit={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                  >
                    {errors.password && touched.password && errors.password}
                  </motion.div>
                )}
              </AnimatePresence>
              <div style={{ position: "relative" }}>
                <input
                  id="login__password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="password"
                  name="password"
                  placeholder="Password"
                  style={
                    errors.password && touched.password
                      ? { border: "2px solid #d3351a" }
                      : {}
                  }
                />
                {errors.password && touched.password && (
                  <MdError
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "20px",
                      color: "#d3351a",
                    }}
                  />
                )}
              </div>
              <button disabled={isSubmitting} className="submit" type="submit">
                {isSubmitting ? <SmallLoader color={"#ffff"} /> : "Sign in"}
              </button>
            </form>
          )}
        </Formik>
      )}
    </>
  );
}

export default CompanyLoginForm;
